const PHOTOS_EVENT = {
  CROP: 'Photo editing > Crop',
  ZOOM: 'Photo editing > Zoom',
  ROTATE: 'Photo editing > Rotate',
  FLIP: 'Photo editing > Flip',
  RESET: 'Photo editing > Reset',
  SAVE: 'Photo editing > Save',
  BACK: 'Photo editing > Back',
  CLOSE_MODAL: 'Photo editing > Close modal',
}

export {
  PHOTOS_EVENT,
}
